import { useAdjudicationData } from 'src/contexts/AdjudicationDataProvider';
import { useAssessmentData } from 'src/contexts/AssessmentDataProvider';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';

export const useWorkflow = (
  entryPoint:
    | 'submission'
    | 'review'
    | 'early-assessment'
    | 'adjudication' = 'submission'
) => {
  const { workflowResponse, availableActions, organizationId } =
    entryPoint === 'submission'
      ? useSubmissionData()
      : entryPoint === 'early-assessment'
      ? useAssessmentData()
      : entryPoint === 'adjudication'
      ? useAdjudicationData()
      : useReviewData();
  const {
    forms,
    articleWorkflow,
    workflowData,
    submissionContextId,
    submissionId
  } = workflowResponse;
  const currentState = workflowData.currentState;

  return {
    forms,
    articleWorkflow,
    currentState,
    submissionContextId,
    organizationId,
    submissionId,
    availableActions
  };
};
